import { Skeleton } from "antd";
import BackPageHeading from "components/BackPageHeading.component";
import { useAuth } from "context/AuthContextProvider";
import AdminUsersTab from "pages/business/components/BusinessAdmins";
import { getBusinessById } from "hooks/queries/business";
import PATHS from "shared/constants/paths";
import { translate } from "shared/languages";

// Manager-facing equivalent of the SystemAdmin's Business Details "Akun" tab,
// scoped to the Manager's own business (no business picker: a Manager only
// ever manages their own business's accounts; the server enforces this too).
// Reached from Pengaturan > Tim & Akses, so it carries the same back arrow as
// every other settings sub-page.
const AccountsPage = () => {
  const { state } = useAuth();
  const businessId = state.business?.id;
  const { data: business } = getBusinessById(businessId);

  return (
    <>
      <BackPageHeading
        title={translate("admin_accounts")}
        backTo={PATHS.SETTINGS}
      />
      {business ? (
        <AdminUsersTab
          admins={business.admins ?? []}
          businessId={business.id}
          showHeading={false}
          pageStorageKey="accounts"
        />
      ) : (
        <Skeleton active />
      )}
    </>
  );
};

export default AccountsPage;
